module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("Ок")]), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.noCancel),
            expression: "!noCancel"
          }],
          on: {
            "click": _vm.cancel
          }
        }, [_vm._v("Отмена")])]
      },
      proxy: true
    }])
  }, [_c('v-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.question)
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5781f558","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ConfirmForm.vue
// module id = 802
// module chunks = 1